import request from '@/utils/request'
const BASE_URL = '/TeachArea'

export default {
    list(data) {
        return request({
            url: BASE_URL + '/List',
            method: 'post',
            data
        })
    },
    info(id) {
        return request({
            url: BASE_URL + '/Info',
            method: 'get',
            params: { id }
        })
    },
    save(data) {
        return request({
            url: BASE_URL + '/Save',
            method: 'post',
            data
        })
    },
    getAddress(lat, lng) {
        return request({
            url: BASE_URL + '/GetAddress?lat=' + lat + "&lng=" + lng,
            method: 'post',
            // data: { lat, lng }
        })
    },
    submit(data) {
        return request({
            url: BASE_URL + '/Submit',
            method: 'post',
            data
        })
    },
    pass(data) {
        return request({
            url: BASE_URL + '/pass',
            method: 'post',
            data
        })
    },
    back(data) {
        return request({
            url: BASE_URL + '/Back',
            method: 'post',
            data
        })
    },
    cancelReview(data) {
        return request({
            url: BASE_URL + '/CancelReview',
            method: 'post',
            data
        })
    },
    delete(data) {
        return request({
            url: BASE_URL + '/Delete',
            method: 'post',
            data
        })
    },
    getMaxSort(pid) {
        return request({
            url: BASE_URL + '/GetMaxSort',
            method: 'get',
            params: { pid }
        })
    },
    record(data) {
        return request({
            url: BASE_URL + '/Record',
            method: 'post',
            data
        })
    },
    unRecord(data) {
        return request({
            url: BASE_URL + '/UnRecord',
            method: 'post',
            data
        })
    },
    checkReview(data) {
        return request({
            url: BASE_URL + '/CheckReview',
            method: 'post',
            data
        })
    },
}